import {
  BIG_CITIES,
  BIG_CITIES_RADIUS,
  DEFAULT_RADIUS,
  OBLAST_CENTERS_CITIES,
  OBLAST_CENTERS_RADIUS,
} from '@/modules/Maps/helpers/constants';

export const getRadiusFromCityName = (cityName: string) => {
  if (BIG_CITIES.includes(cityName)) {
    return BIG_CITIES_RADIUS;
  } else if (OBLAST_CENTERS_CITIES.includes(cityName)) {
    return OBLAST_CENTERS_RADIUS;
  } else {
    return DEFAULT_RADIUS;
  }
};
